import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, [
  /*#__PURE__*/_createTextVNode(" 请上传jpg/png的统一尺寸图片，图片比例为1:1，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 推荐尺寸：200px*200px,图片大小不能大于2M ")
], -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "el-upload__tip" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "请上传jpg/png的统一尺寸图片，图片比例为1:1，", -1)
const _hoisted_8 = { style: {"display":"flex"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片比例为3:4，推荐尺寸：390px*520px,图片大小不能大于6M ", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片比例为7:4，推荐尺寸：350px*200px,图片大小不能大于6M ", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片比例为1:2，推荐尺寸：350px*700px,图片大小不能大于10M ", -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, " 实力 ", -1)
const _hoisted_16 = { class: "dialog-footer" }

import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'
import { isTemplate } from 'element-plus/es/utils'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

  const router = useRouter()
  const route = useRoute()
  const baseData = reactive({
    loading: false,
    tipsbox: false,
    cateslist: [],
    memberlist: [],
  })
  const propss = {
    expandTrigger: 'hover' as const,
    value:'id',
    label:'title',
    children:'children',
  }
  const form:any = reactive({
    id: '',
    memberid:'',
    cid:'',
    cates: [],
    imglist: [],
    aboutimglist: [],
    detailimglist: [],
    title:'',
    subtitle:'',
    img:'',
    contactImg:'',
    name: '',
    position: '',
    phone: '',
    email: '',
    address: '',
    wxcode: '',
    website: '',
    isRecommend: '',
    isTop: '',
    introduction: '',
    end_time: '',
    status: 1,
  })
  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)
  const dialogAboutImageUrl = ref('')
  const dialogAboutVisible = ref(false)
  const dialogDetailImageUrl = ref('')
  const dialogDetailVisible = ref(false)

  const showtipsbox = () => {
    baseData.tipsbox = true
  }
  const getCatesList = () => {
    baseData.loading = true
    api.companyApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCompanyMemberList = () => {
    api.memberApi.getCompanyMemberList({limit:3000,page:1,cid:route.params.id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.memberlist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleChange = (value:any) => {
    form.cid = value[value.length - 1]
  }
  const get = () => {
    const loading = ElLoading.service({lock: true})
    api.companyApi.get({id:route.params.id}).then((res:any)=>{
      if(res.code==200){
        form.memberid = res.data.companyinfo.memberid
        form.cid = res.data.companyinfo.cid
        form.cate = res.data.companyinfo.cate
        form.cates = res.data.companyinfo.cates
        for(let i=0;i<form.cates.length;i++){
          form.cates[i] = parseInt(form.cates[i])
        }
        form.img = res.data.companyinfo.img
        form.contactImg = res.data.companyinfo.contactImg
        form.imglist = res.data.imglist ? res.data.imglist : []
        form.aboutimglist = res.data.aboutimglist ? res.data.aboutimglist : []
        form.detailimglist = res.data.detailimglist ? res.data.detailimglist : []
        form.title = res.data.companyinfo.title
        form.subtitle = res.data.companyinfo.subtitle
        form.name = res.data.companyinfo.name
        form.position = res.data.companyinfo.position
        form.phone = res.data.companyinfo.phone
        form.email = res.data.companyinfo.email
        form.address = res.data.companyinfo.address
        form.wxcode = res.data.companyinfo.wxcode
        form.website = res.data.companyinfo.website
        form.introduction = res.data.companyinfo.introduction
        form.isRecommend= res.data.companyinfo.isRecommend == 1 ? true : false
        form.isTop= res.data.companyinfo.isTop == 1 ? true : false
        form.end_time= res.data.companyinfo.end_time
        form.status = String(res.data.companyinfo.status)
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const onSubmit = () => {
    let data = {...form};
    data.isTop = data.isTop == true ? 1 : 0
    data.isRecommend = data.isRecommend == true ? 1 : 0
    data.cates = data.cates.length > 0 ? data.cates.join(',') : ''
    data.imglist = data.imglist.length ? JSON.stringify(data.imglist) : ""
    data.aboutimglist = data.aboutimglist.length ? JSON.stringify(data.aboutimglist) : ""
    data.detailimglist = data.detailimglist.length ? JSON.stringify(data.detailimglist) : ""
    const loading = ElLoading.service({lock: true})
    api.companyApi.edit(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/company");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  const uploadLogo = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('Logo图超过2MB!')
        return false
    }
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadcontactimg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('联系二维码图超过2MB!')
        return false
    }
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.contactImg = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data = {name:file.name,url:res.data.img}
        form.imglist.pop()
        form.imglist.push(data);
        }
    })
  }
  const uploadAboutImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data = {name:file.name,url:res.data.img}
        form.aboutimglist.pop()
        form.aboutimglist.push(data);
        }
    })
  }
  const uploadDetailImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过10MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data = {name:file.name,url:res.data.img}
        form.detailimglist.pop()
        form.detailimglist.push(data);
        }
    })
  }
  const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url!
    dialogVisible.value = true
  }

  const handleAboutRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handleAboutPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogAboutImageUrl.value = uploadFile.url!
    dialogAboutVisible.value = true
  }
  const handleDetailRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handleDetailPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogDetailImageUrl.value = uploadFile.url!
    dialogDetailVisible.value = true
  }
  onMounted(() => {
    form.id = route.params.id
    get()
    getCatesList()
    getCompanyMemberList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/company' } }, {
                default: _withCtx(() => [
                  _createTextVNode("公司列表")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("编辑公司")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            model: form,
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "公司名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                    maxlength: "150",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "公司简称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.subtitle,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.subtitle) = $event)),
                    maxlength: "150",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "管理者" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.memberid,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.memberid) = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.memberlist, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.nickname,
                          value: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.nickname), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "分类名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_cascader, {
                    modelValue: form.cates,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.cates) = $event)),
                    options: baseData.cateslist,
                    props: propss,
                    clearable: "",
                    onChange: handleChange
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form, {
                model: form,
                inline: true,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "Logo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { class: "martop" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            class: "avatar-uploader",
                            action: "",
                            "http-request": uploadLogo,
                            "show-file-list": false
                          }, {
                            tip: _withCtx(() => [
                              _hoisted_4
                            ]),
                            default: _withCtx(() => [
                              (form.img)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: form.img,
                                    class: "avatar"
                                  }, null, 8, _hoisted_3))
                                : (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 1,
                                    class: "avatar-uploader-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "联系二维码图" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { class: "martop" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            class: "avatar-uploader",
                            action: "",
                            "http-request": uploadcontactimg,
                            "show-file-list": false
                          }, {
                            tip: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("div", _hoisted_8, [
                                  _createTextVNode("推荐尺寸：200px*200px,图片大小不能大于2M,"),
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showtipsbox())),
                                    link: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("查看示例")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            default: _withCtx(() => [
                              (form.contactImg)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: form.contactImg,
                                    class: "avatar"
                                  }, null, 8, _hoisted_5))
                                : (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 1,
                                    class: "avatar-uploader-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_el_form_item, { label: "banner轮播图" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    "file-list": form.imglist,
                    "onUpdate:fileList": _cache[5] || (_cache[5] = ($event: any) => ((form.imglist) = $event)),
                    action: "",
                    "http-request": uploadImg,
                    "list-type": "picture-card",
                    "on-preview": handlePictureCardPreview,
                    "on-remove": handleRemove
                  }, {
                    tip: _withCtx(() => [
                      _hoisted_9
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["file-list"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        "w-full": "",
                        src: dialogImageUrl.value,
                        alt: "Preview Image"
                      }, null, 8, _hoisted_10)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form, {
                model: form,
                inline: true,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "更多设置" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: form.isRecommend,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.isRecommend) = $event)),
                        label: "推荐"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: form.isTop,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.isTop) = $event)),
                        label: "顶置"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_el_form, {
                model: form,
                inline: true,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "公司联系人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.name,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.name) = $event)),
                        maxlength: "150",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "微信号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.wxcode,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.wxcode) = $event)),
                        maxlength: "150",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "网址" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.website,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.website) = $event)),
                        maxlength: "250",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "职位" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.position,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.position) = $event)),
                        maxlength: "150",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "公司电话" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.phone,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.phone) = $event)),
                        maxlength: "150",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "邮箱" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.email,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.email) = $event)),
                        maxlength: "150",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "地址",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.address,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.address) = $event)),
                        maxlength: "250",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "简介",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: form.introduction,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.introduction) = $event)),
                        maxlength: "250",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_el_form_item, { label: "关于我们-轮播图" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    "file-list": form.aboutimglist,
                    "onUpdate:fileList": _cache[17] || (_cache[17] = ($event: any) => ((form.aboutimglist) = $event)),
                    action: "",
                    "http-request": uploadAboutImg,
                    "list-type": "picture-card",
                    "on-preview": handleAboutPictureCardPreview,
                    "on-remove": handleAboutRemove
                  }, {
                    tip: _withCtx(() => [
                      _hoisted_11
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["file-list"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: dialogAboutVisible.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((dialogAboutVisible).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        "w-full": "",
                        src: dialogAboutImageUrl.value,
                        alt: "Preview Image"
                      }, null, 8, _hoisted_12)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "公司详情图" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    "file-list": form.detailimglist,
                    "onUpdate:fileList": _cache[19] || (_cache[19] = ($event: any) => ((form.detailimglist) = $event)),
                    action: "",
                    "http-request": uploadDetailImg,
                    "list-type": "picture-card",
                    "on-preview": handleDetailPictureCardPreview,
                    "on-remove": handleDetailRemove
                  }, {
                    tip: _withCtx(() => [
                      _hoisted_13
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["file-list"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: dialogDetailVisible.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((dialogDetailVisible).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        "w-full": "",
                        src: dialogDetailImageUrl.value,
                        alt: "Preview Image"
                      }, null, 8, _hoisted_14)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: form.status,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "0" }, {
                        default: _withCtx(() => [
                          _createTextVNode("冻结")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("待审核")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("正常")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: onSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: goBack }, {
                    default: _withCtx(() => [
                      _createTextVNode("返回")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.tipsbox,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((baseData.tipsbox) = $event)),
      title: "提示"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (baseData.tipsbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (baseData.tipsbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_15
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})